const DEFAULT_SANDBOX_ALLOWED_EMAIL_SUFFIXES = ['@tbd.health', '@hellowisp.com'];

const SANDBOX_ENV_VALUE = 'sandbox';

/**
 * True when this build targets the sandbox patient portal (REACT_APP_ENV).
 */
export const IS_SANDBOX_ENV =
  (process.env.REACT_APP_ENV || '').toLowerCase() === SANDBOX_ENV_VALUE;

/**
 * Merges default sandbox email suffixes with optional extras from
 * REACT_APP_SANDBOX_ALLOWED_EMAIL_SUFFIXES (comma-separated). Tokens without
 * a leading @ are normalized to suffix form (e.g. partner.com -> @partner.com).
 */
export function mergeSandboxEmailSuffixes(extraFromEnv) {
  const base = DEFAULT_SANDBOX_ALLOWED_EMAIL_SUFFIXES.map(s => s.toLowerCase());
  if (!extraFromEnv || typeof extraFromEnv !== 'string' || !extraFromEnv.trim()) {
    return [...base];
  }

  const out = [...base];
  const tokens = extraFromEnv
    .split(',')
    .map(t => t.trim().toLowerCase())
    .filter(Boolean);

  for (let token of tokens) {
    if (!token.startsWith('@')) {
      token = `@${token}`;
    }
    if (!out.includes(token)) {
      out.push(token);
    }
  }
  return out;
}

export const SANDBOX_ALLOWED_EMAIL_SUFFIXES = mergeSandboxEmailSuffixes(
  process.env.REACT_APP_SANDBOX_ALLOWED_EMAIL_SUFFIXES
);
